const question = {
    securityProgress: { point: [1], resolvedProfile: 'P' },
    moderateProgress: { point: [2] },
    highProgress: { point: [3] },
    highProgressHighRisk: { point: [4] },
};

export default question;
